import io from "socket.io-client";
import { getServerOrigin } from "./utils";

let socket = null;

function connectSocket() {
	if (!socket) {
		socket = io(getServerOrigin(), { withCredentials: true });
	}
}

function disconnectSocket() {
	if (socket) {
		socket.disconnect();
		socket = null;
	}
}
export { connectSocket, disconnectSocket, socket };
